"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("./topbar.scss");

var _LogoTopLeft = _interopRequireDefault(require("../LogoTopLeft"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// import React from 'react';
var TopBar = function TopBar(_ref) {
  var style = _ref.style,
      logoClick = _ref.logoClick,
      leftExtra = _ref.leftExtra,
      title = _ref.title,
      rightMenu = _ref.rightMenu;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: style,
    className: "p-topbar level is-marginless",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "level-left p-empty-flex-align",
      style: {
        position: "relative",
        zIndex: 2
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LogoTopLeft["default"], {
        className: "level-item svg-fill-primary",
        logoClick: logoClick,
        child: !!leftExtra && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "p-padding-left-5",
          children: leftExtra
          /* <GoBack action={goBack}/> */

        })
      })
    }), !!title && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        position: "absolute"
      },
      className: "p-full-width p-both-center",
      children: title
    }), !!rightMenu ? rightMenu : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "p-empty-flex-align level-right is-hidden-mobile",
      style: {
        position: "relative",
        zIndex: 2
      }
    })]
  });
};

var _default = TopBar;
exports["default"] = _default;